import { logWrapper } from '../utils';

export default [
  'runtimeConstant',
  'authService',
  '$rootScope',
  '$location',
  '$state',
  '$urlRouter',
  '$anchorScroll',
  '$transitions',
  function (
    runtimeConstant,
    authService,
    $rootScope,
    $location,
    $state,
    $urlRouter,
    $anchorScroll,
    $transitions
  ) {
    function handleSecurePath(authService, $location) {
      const securePaths = ['/workflow', '/admin'];
      const currentPath = $location.path();

      // Check if the current path belongs to any of the secure paths
      const requiresAuth = securePaths.some((path) =>
        currentPath.includes(path)
      );

      if (requiresAuth) {
        // Attempt to load user data if the path is secure
        authService
          .loadUser()
          .then(() => {
            // eslint-disable-next-line no-console
            console.log('User loaded successfully');
          })
          .catch(() => {
            // eslint-disable-next-line no-console
            console.error('Failed to load user');

            // If user data cannot be loaded, redirect to login page
            $location.search('redirectUrl', currentPath);
            $location.path('/login');
          });
      }
    }

    function onResize() {
      $rootScope.$apply();
    }

    function onStart(transition) {
      const toState = transition.to();
      const toParams = transition.params();

      const ignoreList = [
        'login',
        'logout',
        'autologin',
        'home.homeToken',
        'publicView',
        '404',
        'revisionNotFound',
        'forgotPassword',
        'recoverPassword',
        'requestPasswordInfo',
      ];

      // Skip checks for ignored states
      if (ignoreList.includes(toState.name)) {
        if (runtimeConstant.isDebugRunnersTransitions) {
          // eslint-disable-next-line no-console
          console.log('The transition started with skip: ', transition.to().name);
        }
        return true;
      }

      // Handle redirectTo
      if (toState.redirectTo) {
        if (runtimeConstant.isDebugRunnersTransitions) {
          // eslint-disable-next-line no-console
          console.log(
            'The transition started with redirect to ' +
              toState.redirectTo +
              ': ',
            transition.to().name
          );
        }
        return transition.router.stateService.target(
          toState.redirectTo,
          toParams,
          { location: 'replace' }
        );
      }

      // Redirects the user to the 'login' state
      if (authService.authentication.isAuth !== true) {
        if (runtimeConstant.isDebugRunnersTransitions) {
          // eslint-disable-next-line no-console
          console.log(
            'The transition started with redirect to login: ',
            transition.to().name
          );
        }
        $rootScope.returnState = toState;
        $rootScope.returnParams = toParams;
        return transition.router.stateService.target('login', {
          redirectUrl: $state.href(toState, toParams),
        });
      }

      if (runtimeConstant.isDebugRunnersTransitions) {
        // eslint-disable-next-line no-console
        console.log('The transition started:', transition.to().name);
      }

      return true;
    }

    function onSuccess(transition) {
      if (runtimeConstant.isDebugRunnersTransitions) {
        // eslint-disable-next-line no-console
        console.log('The transition succeeded:', transition.to().name);
      }

      //volta para o topo da tela
      $anchorScroll('wrapper');
    }

    function onError(transition) {
      const error = transition.error();

      // If the transition was superseded (type 2) or ignored (type 5), no need to log as error
      if (error && (error.type === 2 || error.type === 5)) {
        if (runtimeConstant.isDebugRunnersTransitions) {
          // eslint-disable-next-line no-console
          console.debug(error.message);
        }
        return;
      }

      // eslint-disable-next-line no-console
      console.error('Transition error:', error);
    }

    function defaultErrorHandler(error) {
      // Check if the error is a "superseded" transition
      if (error && error.message && error.message.includes('The transition has been superseded by a different transition')) {
        if (runtimeConstant.isDebugRunnersTransitions) {
          // eslint-disable-next-line no-console
          console.debug(error.message);
        }
        return; // Suppress the error log
      }

      // For other errors, let them be logged as usual
      // eslint-disable-next-line no-console
      console.error(error);
    }

    function run() {
      try {
        $state.defaultErrorHandler(
          {},
          logWrapper(defaultErrorHandler, runtimeConstant.isDebugRunnersInternals)
        );

        $rootScope.$state = $state;
        $rootScope.onLogin = true;
        $rootScope.title = '';

        authService.fillAuthData();
        $urlRouter.listen();
        $urlRouter.sync();
        handleSecurePath(authService, $location);

        angular
          .element(window)
          .on(
            'resize',
            logWrapper(onResize, runtimeConstant.isDebugRunnersInternals)
          );

        $transitions.onStart(
          {},
          logWrapper(onStart, runtimeConstant.isDebugRunnersInternals)
        );

        $transitions.onSuccess(
          {},
          logWrapper(onSuccess, runtimeConstant.isDebugRunnersInternals)
        );

        $transitions.onError(
          {},
          logWrapper(onError, runtimeConstant.isDebugRunnersInternals)
        );
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }

    // Wrap the setup function with logWrapper for debugging purposes
    logWrapper(run, runtimeConstant.isDebugRunners)();
  },
];
